import { action, makeObservable, observable } from 'mobx';
import { LocalStorageGet, LocalStorageSet } from './Helpers';
import { ApiService } from './ApiService';
import { ApiURL } from '../AppConstants';
import Papa from 'papaparse';

const LANGUAGE_KEY = 'language';
const TRANSLATIONS_KEY = 'translations';
const MAIN_LNG = 'English';
let LOCAL_TRANSLATIONS: Array<string[]> = [];

type TranslateKey = {
    languageKey: string,
    translationKey: string,
    value: string,
}
type TranslateDTO = {
    lng: string,
    translate: TranslateKey[]
}

export class LanguageService {
    @observable public langList: string[] = [];
    @observable public activeLang: string = '';

    constructor () {
        makeObservable(this);
        this.activeLang = this.storedLanguage();
    }

    public async init () {
        return new Promise<void>((resolve) => {
            Papa.parse('/translations.csv', {
                download: true,
                complete: async csv => {
                    LOCAL_TRANSLATIONS = csv.data as Array<string[]>;
                    const { data } = await ApiService.getData<string[]>(`${ApiURL.Languages}`);
                    this.langList = data;
                    const lang = LocalStorageGet<string>(LANGUAGE_KEY) || MAIN_LNG;
                    await this.setLang(lang);
                    resolve()
                }
            });

        })
    }

    public async setLang (lang: string) {
        const translations = lang ? LocalStorageGet<TranslateDTO>(`${TRANSLATIONS_KEY}`) : null;
        LocalStorageSet(LANGUAGE_KEY, lang);
        const { data } = await ApiService.getData<TranslateKey[]>(`${ApiURL.Translations}/${lang}`);
        LocalStorageSet<TranslateDTO>(`${TRANSLATIONS_KEY}`, {
            lng: lang,
            translate: data
        });
        if (JSON.stringify(translations?.translate) !== JSON.stringify(data)) {
            window.location.reload();
        }
    }

    public storedLanguage () {
        return LocalStorageGet<string>(LANGUAGE_KEY) || '';
    }

    @action
    public setActiveLang (lang: string) {
        this.activeLang = lang;
    }
}

export class LNG {
    public static Text (key: string) {
        const lang = LocalStorageGet<string>(LANGUAGE_KEY);
        const translations = lang ? LocalStorageGet<TranslateDTO>(`${TRANSLATIONS_KEY}`) : null;
        const mockText = `{${key}}`;
        const translation = lang && translations && translations.translate.find(e => e.translationKey === key)?.value;
        let storedTranslations = '';
        if (!translation && LOCAL_TRANSLATIONS.length) {
            const lngIndex = LOCAL_TRANSLATIONS[0].indexOf(lang || MAIN_LNG);
            if (lngIndex !== -1) {
                const val = LOCAL_TRANSLATIONS.find(e => e.includes(key));
                if (val) {
                    storedTranslations = val[lngIndex];
                }
            }
        }
        return translation || storedTranslations || mockText;
    }
}